import { render, staticRenderFns } from "./LaborSettlement.vue?vue&type=template&id=0f06888a&scoped=true&"
import script from "./LaborSettlement.vue?vue&type=script&lang=js&"
export * from "./LaborSettlement.vue?vue&type=script&lang=js&"
import style0 from "./LaborSettlement.vue?vue&type=style&index=0&id=0f06888a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f06888a",
  null
  
)

export default component.exports